import { FC, useState } from 'react';
import { AText, Box, Popover } from '@alf/uikit';
import { useDeviceStore } from '@namespace/device';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

interface InfoPopoverProps {
  tooltipTitle?: string[];
}

export const InfoPopover: FC<InfoPopoverProps> = ({ tooltipTitle = [] }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const { isMobile } = useDeviceStore();

  return (
    <Popover
      classNames={{
        contentClass: styles.tooltipContent
      }}
      isOpenExternal={isPopoverOpen}
      setIsOpenExternal={setIsPopoverOpen}
      trigger={
        <Box align="center">
          <Box
            {...(isMobile
              ? { onClick: () => setIsPopoverOpen((prev) => !prev) }
              : {
                  onMouseEnter: () => setIsPopoverOpen(true),
                  onMouseLeave: () => setIsPopoverOpen(false)
                })}
            left="s"
          >
            <Icon
              name={`icons/general/state/info${isPopoverOpen ? '' : '2'}`}
              size="l"
              color="btn_quaternary_color_4"
            />
          </Box>
        </Box>
      }
      content={
        <Box padding="m s" direction="column">
          {tooltipTitle?.map((text) => (
            <AText key={text} breed="R" size="m" color="txt_color_1">
              {text}
            </AText>
          ))}
        </Box>
      }
    />
  );
};
